// 初期表示
export const PAGE_INIT = "corp/overseas/summary/PAGE_INIT";
// グループ 取得
export const GROUP_GET = "corp/summary/GROUP_GET";
